define('OutSystems/ClientRuntime/Decimal',["require", "exports", "decimal", "toformat"], function (require, exports, decimal_1, toformat_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    toformat_1.default(decimal_1.Decimal);
    var Rounding;
    (function (Rounding) {
        Rounding[Rounding["roundUp"] = 0] = "roundUp";
        Rounding[Rounding["roundDown"] = 1] = "roundDown";
        Rounding[Rounding["roundCeil"] = 2] = "roundCeil";
        Rounding[Rounding["roundFloor"] = 3] = "roundFloor";
        Rounding[Rounding["roundHalfUp"] = 4] = "roundHalfUp";
        Rounding[Rounding["roundHalfDown"] = 5] = "roundHalfDown";
        Rounding[Rounding["roundHalfEven"] = 6] = "roundHalfEven";
        Rounding[Rounding["roundHalfCeil"] = 7] = "roundHalfCeil";
        Rounding[Rounding["roundHalfFloor"] = 8] = "roundHalfFloor";
    })(Rounding || (Rounding = {}));
    var decimalJs = decimal_1.Decimal.config({
        precision: 30,
        toExpNeg: -1024,
        toExpPos: 1024,
        rounding: decimal_1.Decimal.Decimal.ROUND_HALF_EVEN,
    });
    var Decimal = (function () {
        function Decimal(value) {
            this.add = this.plus;
            this.sub = this.minus;
            this.eq = this.equals;
            this.lt = this.lessThan;
            this.lte = this.lessThanOrEqualTo;
            this.gt = this.greaterThan;
            this.gte = this.greaterThanOrEqualTo;
            var unwrappedValue = Decimal.unwrapInputValue(value);
            this.internalValue = new decimalJs(unwrappedValue);
        }
        Decimal.unwrapInputValue = function (value) {
            if (typeof value === "string" || typeof value === "number") {
                return value;
            }
            if ("internalValue" in value) {
                return value.internalValue;
            }
            return value;
        };
        Decimal.max = function (valueLeft, valueRigth) {
            var _a = [
                Decimal.unwrapInputValue(valueLeft),
                Decimal.unwrapInputValue(valueRigth),
            ], unwrappedValueLeft = _a[0], unwrappedValueRigth = _a[1];
            var result = decimalJs.max(unwrappedValueLeft, unwrappedValueRigth);
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.min = function (valueLeft, valueRigth) {
            var _a = [
                Decimal.unwrapInputValue(valueLeft),
                Decimal.unwrapInputValue(valueRigth),
            ], unwrappedValueLeft = _a[0], unwrappedValueRigth = _a[1];
            var result = decimalJs.min(unwrappedValueLeft, unwrappedValueRigth);
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.abs = function () {
            var result = this.internalValue.abs();
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.neg = function () {
            var result = this.internalValue.neg();
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.sqrt = function () {
            var result = this.internalValue.sqrt();
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.trunc = function () {
            var result = this.internalValue.trunc();
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.round = function () {
            var result = this.internalValue.round();
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.isNaN = function () {
            var result = this.internalValue.isNaN();
            return result;
        };
        Decimal.prototype.isInteger = function () {
            var result = this.internalValue.isInteger();
            return result;
        };
        Decimal.prototype.decimalPlaces = function () {
            var result = this.internalValue.decimalPlaces();
            return result;
        };
        Decimal.prototype.plus = function (value) {
            var unwrappedValue = Decimal.unwrapInputValue(value);
            var result = this.internalValue.plus(unwrappedValue);
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.minus = function (value) {
            var unwrappedValue = Decimal.unwrapInputValue(value);
            var result = this.internalValue.minus(unwrappedValue);
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.times = function (value) {
            var unwrappedValue = Decimal.unwrapInputValue(value);
            var result = this.internalValue.times(unwrappedValue);
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.div = function (value) {
            var unwrappedValue = Decimal.unwrapInputValue(value);
            var result = this.internalValue.div(unwrappedValue);
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.pow = function (value) {
            var unwrappedValue = Decimal.unwrapInputValue(value);
            var result = this.internalValue.pow(unwrappedValue);
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.mod = function (value) {
            var unwrappedValue = Decimal.unwrapInputValue(value);
            var result = this.internalValue.mod(unwrappedValue);
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.prototype.equals = function (value) {
            var unwrappedValue = Decimal.unwrapInputValue(value);
            var result = this.internalValue.equals(unwrappedValue);
            return result;
        };
        Decimal.prototype.lessThan = function (value) {
            var unwrappedValue = Decimal.unwrapInputValue(value);
            var result = this.internalValue.lessThan(unwrappedValue);
            return result;
        };
        Decimal.prototype.lessThanOrEqualTo = function (value) {
            var unwrappedValue = Decimal.unwrapInputValue(value);
            var result = this.internalValue.lessThanOrEqualTo(unwrappedValue);
            return result;
        };
        Decimal.prototype.greaterThan = function (value) {
            var unwrappedValue = Decimal.unwrapInputValue(value);
            var result = this.internalValue.greaterThan(unwrappedValue);
            return result;
        };
        Decimal.prototype.greaterThanOrEqualTo = function (value) {
            var unwrappedValue = Decimal.unwrapInputValue(value);
            var result = this.internalValue.greaterThanOrEqualTo(unwrappedValue);
            return result;
        };
        Decimal.prototype.toString = function () {
            var result = this.internalValue.toString();
            return result;
        };
        Decimal.prototype.toNumber = function () {
            var result = this.internalValue.toNumber();
            return result;
        };
        Decimal.prototype.valueOf = function () {
            var result = this.internalValue.valueOf();
            return result;
        };
        Decimal.prototype.toFixed = function (decimalPlaces) {
            var result = this.internalValue.toFixed(decimalPlaces);
            return result;
        };
        Decimal.prototype.toFormat = function () {
            var _a;
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            var result = (_a = this.internalValue).toFormat.apply(_a, params);
            return result;
        };
        Decimal.prototype.toDecimalPlaces = function (decimalPlaces) {
            var result = this.internalValue.toDecimalPlaces(decimalPlaces);
            var newInstance = new Decimal(result);
            return newInstance;
        };
        Decimal.rounding = decimalJs.rounding;
        Decimal.defaultValue = new Decimal(0);
        return Decimal;
    }());
    exports.default = Decimal;
});
//# sourceMappingURL=Decimal.js.map;
